import { SvgIconComponent } from '@mui/icons-material';
import { Icon, IconProps, SvgIconProps, SxProps } from '@mui/material';
import { FC } from 'react';

type SpinningIconProps = {
  icon: SvgIconComponent;
  iconProps?: SvgIconProps;
  sx?: SxProps;
};

const SpinningIcon: FC<SpinningIconProps> = (props) => {
  return (
    <Icon
      {...props.iconProps}
      component={props.icon}
      sx={{
        animation: 'spin 2s linear infinite',
        '@keyframes spin': {
          '0%': {
            transform: 'rotate(360deg)'
          },
          '100%': {
            transform: 'rotate(0deg)'
          }
        },
        ...props.sx
      }}
    />
  );
};

export default SpinningIcon;
